import { render, staticRenderFns } from "./BaseNavbar.vue?vue&type=template&id=723a0d55&scoped=true&"
import script from "./BaseNavbar.vue?vue&type=script&lang=js&"
export * from "./BaseNavbar.vue?vue&type=script&lang=js&"
import style0 from "./BaseNavbar.vue?vue&type=style&index=0&id=723a0d55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723a0d55",
  null
  
)

export default component.exports